export default __webpack_public_path__ + "75a5e0f8e00e5eac47f604402c9f0be1.svg";